import { api } from './api'

export interface ReportCard {
  student: { id: number; name: string; student_id: string; admission_number: string; class_name: string }
  academic_year?: { id: number; name: string } | null
  term: string
  results: Array<{ result_id: number; subject: string; examination: string; marks: number; total_marks: number; percentage: number; division: string; remarks: string; published: boolean }>
  summary: { subjects: number; average_percentage: number; overall_division: string; passes: number }
}

export interface AcademicReportSummary {
  results_recorded: number
  average_percentage: number
  learners: Array<{ student_id: number; name: string; class_name: string; subjects: number; average_percentage: number; division: string }>
}

const query = (params?: { academic_year?: number | string; term?: string; class_id?: number | string }) => ({ params })

export const reportService = {
  getReportCard: async (studentId: number, params?: { academic_year?: number | string; term?: string }) =>
    (await api.get(`/reports/report-cards/${studentId}/`, query(params))).data as ReportCard,
  getAcademicSummary: async (params?: { academic_year?: number | string; term?: string; class_id?: number | string }) =>
    (await api.get('/reports/summaries/academic/', query(params))).data as AcademicReportSummary,
  // Every class in the school, not just ones the caller personally teaches --
  // the summary above is already unscoped by personal assignment for anyone
  // who can see this page, so the filter that narrows it has to match.
  getAcademicReportClasses: async () =>
    (await api.get('/reports/summaries/academic/classes/')).data as Array<{ id: number; name: string }>,
  // Real AcademicTerm ids -- the backend can only filter reliably by term id,
  // not by typed-out text like "Term I" (see the view's own docstring).
  getAcademicReportTerms: async () =>
    (await api.get('/reports/summaries/academic/terms/')).data as Array<{ id: number; name: string; is_current: boolean }>,
  downloadReportCard: async (studentId: number, params?: { academic_year?: number | string; term?: string }) => {
    const response = await api.get(`/reports/report-cards/${studentId}/pdf/`, { ...query(params), responseType: 'blob' })
    const url = URL.createObjectURL(response.data)
    const anchor = document.createElement('a')
    anchor.href = url; anchor.download = `report-card-${studentId}.pdf`; anchor.click()
    URL.revokeObjectURL(url)
  },
}
